import Ajv from 'ajv';
import addErrors from 'ajv-errors';
import addFormats from 'ajv-formats';
import { setWith } from 'lodash';

// Import all validation's schemas
import { auth } from 'schemas/Authentication/auth';
import { forgot } from 'schemas/Authentication/forgot';
import { reset } from 'schemas/Authentication/reset';
import { password } from 'schemas/password';

// @User schemas
import { user } from 'schemas/User/index';
import { address } from 'schemas/User/address';

// @Teacher schemas
import { teacherCourses } from 'schemas/User/teacher-courses';

// @Student schemas
import { studentGrades } from 'schemas/User/student-grades';
import { studentCourses } from 'schemas/User/student-courses';
import { studentExams } from 'schemas/User/student-exams';

// @Article schemas
import { article } from 'schemas/article';

// @Program schemas
import { program } from 'schemas/program';

// @Exam schemas
import { exam } from 'schemas/exam';

// @Webinar schemas
import { webinar } from 'schemas/webinar';

// @Blank schemas
import { blank } from 'schemas/blank';

// @Grade schemas
import { grade } from 'schemas/grade';

// @Course schemas
import { course } from 'schemas/course';

// @Subject schemas
import { subject } from 'schemas/subject';

// @Material schemas
import { material } from 'schemas/material';

// @Task schemas
import { task } from 'schemas/Task/task';
import { taskDefaultQuestions } from 'schemas/Task/taskDefaultQuestions';
import { taskQuizQuestions } from 'schemas/Task/taskQuizQuestions';
import { taskQuizOptions } from 'schemas/Task/taskQuizOptions';
import { taskSpellcheckQuestions } from 'schemas/Task/taskSpellcheckQuestions';
import { taskSpellcheckWords } from 'schemas/Task/taskSpellcheckWords';
import { taskConnectQuestions } from 'schemas/Task/taskConnectQuestions';

// Create ajv validator instance
const Validator = new Ajv({
	allErrors: true
});

// Append errors and formats to validator
addErrors(Validator);
addFormats(Validator);

// Parse errors to readable format
// @errors: array | ajv errors
export const Parser = errors => {
	return errors.reduce((result, { instancePath, message, params }) => {
		const [, ...path] = instancePath.split('/');

		if (params.missingProperty) {
			result = setWith(result, [...path, params.missingProperty].join('.'), message);
		} else if (params.errors) {
			params.errors.forEach(error => {
				result = setWith(result, error.params.missingProperty, message);
			});
		}

		return result;
	}, {});
};

// Add all schemas
Validator.addSchema(auth, '/auth');
Validator.addSchema(forgot, '/forgot');
Validator.addSchema(reset, '/reset');
Validator.addSchema(password, '/password');

Validator.addSchema(user, '/user');
Validator.addSchema(address, '/address');

Validator.addSchema(teacherCourses, '/teacher-courses');
Validator.addSchema(studentGrades, '/student-grades');
Validator.addSchema(studentCourses, '/student-courses');
Validator.addSchema(studentExams, '/student-exams');

Validator.addSchema(article, '/article');
Validator.addSchema(program, '/program');
Validator.addSchema(exam, '/exam');
Validator.addSchema(webinar, '/webinar');
Validator.addSchema(blank, '/blank');
Validator.addSchema(grade, '/grade');
Validator.addSchema(course, '/course');
Validator.addSchema(subject, '/subject');
Validator.addSchema(material, '/material');

Validator.addSchema(task, '/task');
Validator.addSchema(taskDefaultQuestions, '/task-default-questions');
Validator.addSchema(taskQuizQuestions, '/task-quiz-questions');
Validator.addSchema(taskQuizOptions, '/task-quiz-options');
Validator.addSchema(taskSpellcheckQuestions, '/task-spellcheck-questions');
Validator.addSchema(taskSpellcheckWords, '/task-spellcheck-words');
Validator.addSchema(taskConnectQuestions, '/task-connect-questions');

export default Validator;
